import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, TemplateRef, ViewChild} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ModalDismissReasons, NgbModal, NgbModalRef, NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {animate, state, style, transition, trigger} from "@angular/animations";
import { bouncy, dotWave, metronome, ping, quantum } from 'ldrs';
import {UserService} from "../../services/user.service";
import {ApiRequestService} from "../../services/api-request.service";
import { AsyncPipe } from "@angular/common";
import {LanguagePipe, MarkdownComponent, MarkdownModule, MarkdownPipe, MarkdownService} from "ngx-markdown";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ParameterService} from "../../services/parameter.service";
import {FeedbackComponent} from "../feedback/feedback.component";
import { HttpEvent, HttpEventType, HttpParams, HttpResponse } from "@angular/common/http";
import {AppConfigService} from "../../app-config.service";
import {CookieService} from "../../services/cookie.service";
export interface ChatItem {
    class: string;
    text: string;
    intent: string;
    review: boolean|null;
    feedback?: string|null;
    feedbackSent: boolean;
    id?: string;
}
export interface chatResponse {
    id: string;
    content: string;
}
@Component({
    selector: '[app-digital-assistant]',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MarkdownComponent,
        MarkdownModule,
    ],
    providers: [],
    standalone: true,
    templateUrl: './digital-assistant.component.html',
    styleUrl: './digital-assistant.component.scss',
    animations: [
        trigger('conversationWindow', [
            // state('open', style({opacity:1,height:'470px',width:'100%'})),
            // state('closed', style({opacity:0,height:'0',width:'0'})),
            state('open', style({ opacity: 1, bottom: 0, right: 0, height: '470px', width: '100%' })),
            state('closed', style({ opacity: 0, bottom: '-470px', right: '-100%', height: '0', width: '0' })),
            transition('open => closed', [animate('0.3s')]),
            transition('closed => open', [animate('0.3s')])
        ]),
        trigger('chatIcon', [
            state('up', style({ bottom: '0' })),
            state('down', style({ bottom: '-110px' })),
            transition('up => down', [animate('0.75s')]),
            transition('down => up', [animate('0.75s')])
        ]),
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DigitalAssistantComponent {
    public is_conversation_visible: boolean = false;
    public is_chaticon_visible: boolean = false;
    public is_loading: boolean = false;
    public userInput: string = "";
    public chatHistory: Array<ChatItem> = [];

    private introText: string = ""
    private testReponse: string = "";
    @ViewChild('chatWindow') private myScrollContainer: ElementRef;

    private modalService = inject(NgbModal);
    private modalReference: NgbModalRef;
    public closeResult = '';

    private testData: any[] = [
        {"class":"ai","text":"Hi Geoffrey Cotton. I'm your PAWS IT Digital Assistant. A virtual assistant expertly trained in USask IT knowledge. Interact with me as you would a conversation. I will share my expertise with you.<br /><br />What can I help you with today ?","intent":"","review":null,"feedbackSent":false},
        {"class":"user","text":"is there a microphone in arts 143","intent":"","review":null,"feedbackSent":false},
        {"class":"ai","text":"**Process Description:**\n\nTo determine if there is a microphone in Arts 143, we will review the \"Available Technology\" section from the provided context.\n\n**Steps:**\n\n1. **Review Available Technology Section**\n   - Examine the list of room features under \"Available Technology\" to identify any mention of microphones.\n   \n2. **Identify Relevant Room Features**\n   - Look for specific mentions of microphone types and their availability in Arts 143.\n\n3. **Confirm Microphone Presence**\n   - Note that Arts 143 is equipped with:\n     - 1 x Lapel mic\n     - 2 x Handheld mics\n\n4. **Technical Requirements**\n   - Ensure familiarity with how to operate the microphones if needed, including connecting and using them during presentations.\n\n**Waiting Periods or Important Warnings:**\n\n- No specific waiting periods are mentioned.\n- Ensure compatibility of any additional audio equipment with the room's microphone system.\n\n**Conclusion:**\n\nBased on the available technology section, Arts 143 is equipped with both a lapel microphone and two handheld microphones for voice reinforcement.\n\nRelated:\n\n[1]  [Arts 143](https://teamdynamix.usask.ca/TDClient/33/Portal/KB/ArticleDet?ID=1698)\n\n","intent":"It seems like you're asking about the availability of a microphone in Arts Building, Room 143. I've interpreted your question as needing information on classroom technology, which falls under IT Services. Let me see what I can find regarding equipment in that specific room.\n","review":null,"id":3314,"feedbackSent":false}
    ];

    constructor(
        private userService: UserService,
        private api: ApiRequestService,
        private appConfig: AppConfigService,
        private cookieService: CookieService
    ) {
        this.introText = "Hi "+ this.userService.getUserName() +"! <br /><br />I'm your <b>PAWS IT Digital Agent</b>. here to help with questions about services and support. Right now, I’m trained on the USask IT knowledge base, but I’ll continue learning and expanding into other service areas over time. Your feedback (thumbs up/down) helps improve my responses as I grow.<br /><br />Feel free to chat with me like you would with a service agent. The clearer your question, the better I can assist you!<br /><br /><b>What can I help you with today?</b>";
        quantum.register();
    }

    ngOnInit() {
        if ( this.hasChatHistory() ) {
            this.getChatHistory();
        } else {
            this.chatHistory.push( { class:"ai", text:this.introText, intent:"", review:null, feedbackSent:false } );
        }

    }

    public get displayName() {
        return this.userService.getUser().displayName;
    }

    @ViewChild("searchinput") private searchinput: ElementRef | null = null;
    public submitText($event? :any) {
        if ( $event != undefined ) {
            var chr = String.fromCharCode($event.keyCode);
        }
        this.userInput = this.searchinput.nativeElement.innerText.trim();
        if ( this.userInput != '' && !this.is_loading ) {
            this.chatHistory.push({class: "user", text: this.userInput, intent:"", review:null, feedbackSent:false });
            this.gotoBottom();
            let text = this.userInput;
            this.userInput = "";
            this.searchinput.nativeElement.innerText = "";
            setTimeout(() => {
                this.is_loading = true;
                this.gotoBottom();
                this.send( text );
                // if (!this.userService.isLoggedIn()) {
                //     let queryParams: Params = {};
                //     queryParams['channel'] = 'chat';
                //     queryParams['keyword'] = text;
                //     this.parameterService.add( queryParams );
                //     this.router.navigate(["/login"], {queryParams: { 'channel': 'chat' } });
                // } else {
                //     this.send( text );
                // }
            }, 1000);
        }
    }
    public clearHistory() {
        if ( !this.is_loading ) {
            this.chatHistory = [];
            this.chatHistory.push({class: "ai", text: this.introText, intent:"", review:null, feedbackSent: false });
            this.saveChatHistory();
            this.api.clearChatConversation().subscribe({
                next: (resp: any) => {
                    // console.log('Cleared');
                }
            });
        }
    }
    public gotoBottom() {
        setTimeout(() => {
            let height = this.myScrollContainer.nativeElement.scrollHeight;
            this.myScrollContainer.nativeElement.scroll({
                top: height,
                behavior: 'smooth'
            });
        },250);
    }
    public refreshToken( text: string ) {
        this.chatHistory.pop();
        this.chatHistory.push({class: "ai", text: "Please wait while I refresh your login ... ", intent:"", review:null, id: null, feedbackSent: false });
        this.userService.refreshUserToken().subscribe({
            next: () => {
                setTimeout(() => {
                    if ( !this.userService.isTokenExpired() ) {
                        this.chatHistory.pop();
                        this.send(text);
                    }
                },4000);
            }
        });

    }
    public send( text: string ) {

        let me = this;
        let url = this.appConfig.getChatApi() + "/chat";
        let xrsfCookie = this.cookieService.getCookie("XSRF-TOKEN");

        let HTTPParams = new HttpParams();
        HTTPParams.set( "message", text );

        me.chatHistory.push({class: "ai", text: "", intent:"", review:null, id: null, feedbackSent: false });

        if ( this.userService.isTokenExpired() ) {
            this.refreshToken(text);
            return;
        }

        async function doit() {
            const response = await fetch( url, {
                method: 'POST',
                headers: {
                    'Accept': 'text/event-stream',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-XSRF-TOKEN': xrsfCookie
                },
                credentials: 'include',
                body: "message="+text
            })
            const reader = response.body.getReader()
            const decoder = new TextDecoder();
            let id = "";
            let result = await reader.read();
            let chunkCount = 0;
            while (!result.done) {
                let data: any = decoder.decode(result.value); // .replace("data:","");
                // console.log("chunk is", data);
                let chunks = [];
                if ( data.includes("}{") ) {
                    let tmp = data.replaceAll("}{","}|{");
                    chunks = tmp.split( "|" );
                } else {
                    chunks.push( data );
                }
                chunks.forEach( (c:any) => {
                    let dataChunk: any = "";
                    try {
                        dataChunk = JSON.parse(c);
                    } catch(e) {
                        // console.log( "JSON Parse Failed: ", dataChunk );
                        dataChunk = {};
                        dataChunk.data = "Something went wrong while deciphering the response. Please try your question again.";
                        dataChunk.type = "text";
                        result.done = true;
                    }
                    if ( dataChunk.data != '' ) {
                        if ( dataChunk.type == 'json' ) {
                            id = dataChunk.data.id;
                            me.chatHistory[me.chatHistory.length - 1].id = id;
                            chunkCount++;
                        } else {
                            if ( chunkCount == 1 && me.isNumeric(id) ) {
                                me.chatHistory[me.chatHistory.length - 1].intent = dataChunk.data;
                            } else {
                                me.chatHistory[me.chatHistory.length - 1].text += dataChunk.data;
                            }
                            chunkCount++;
                        }
                        me.gotoBottom();
                    }
                } );
                result = await reader.read();
                me.saveChatHistory();
            }
        }
        doit().then((resp)=>{
            document.getElementById("searchInput").innerText = "";
            me.is_loading = false;
            // console.log( JSON.stringify(me.chatHistory) );
        })
    }
    public submitReview( chatItem: ChatItem, index: number ) {
        // this.chatHistory[index].feedbackSent = true;
        this.api.sendChatItemReview( chatItem ).subscribe({
            next: (resp:any) => {
                this.chatHistory[index].feedbackSent = true;
            }
        });
    }

    private isNumeric(value: string): boolean {
        return !isNaN(Number(value)) && !isNaN(parseFloat(value));
    }

    /**
     * import  *  as CryptoJS from  'crypto-js';
     * private encrypt(txt: string): string {
     *     return CryptoJS.AES.encrypt(txt, this.key).toString();
     * }
     *
     *   private decrypt(txtToDecrypt: string) {
     *     return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
     *   }
     */
    private historyStorageToken = "pawsChatthatHistory";
    public saveChatHistory() {
        sessionStorage.setItem( this.historyStorageToken, JSON.stringify(this.chatHistory) );
    }
    public getChatHistory() {
        this.chatHistory = JSON.parse( sessionStorage.getItem( this.historyStorageToken ) );
    }
    public hasChatHistory(): boolean {
        return ( sessionStorage.getItem( this.historyStorageToken ) != undefined );
    }
    public clearChatHistory() {
        sessionStorage.clear();
    }
    protected readonly createImageBitmap = createImageBitmap;

    open(content: TemplateRef<any>) {
        this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
        this.modalReference.result.then(
        (result) => {
            this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
        );
    }

    private getDismissReason(reason: any): string {
        switch (reason) {
        case ModalDismissReasons.ESC:
            return 'by pressing ESC';
        case ModalDismissReasons.BACKDROP_CLICK:
            return 'by clicking on a backdrop';
        default:
            return `with: ${reason}`;
        }
    }

    public showDisclaimerContent: boolean = false;
    public toggleContent() {

    }
}
